import React, { Component } from 'react';
import windowSize from 'react-window-size';

import './Level.css';

export class Level extends Component {
  state = {
    active: false,
  }
  onClick = () => {
    if (this.state.active) return;
    this.activate();
    this.props.onClick && this.props.onClick();
    setTimeout(this.unlock, 2500);
  }
  activate = () => this.setState({ active: true })
  unlock = () => this.setState({ active: false })
  render() {
    return (
      <div className={`level ${this.state.active ? 'active' : ''}`} onClick={this.onClick}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Controller/Level/Level.js